import { render, staticRenderFns } from "./header-left-aligned-layout-icon.vue?vue&type=template&id=50edb67d&scoped=true&"
import script from "./header-left-aligned-layout-icon.vue?vue&type=script&lang=js&"
export * from "./header-left-aligned-layout-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edb67d",
  null
  
)

export default component.exports